import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SEO from "./SEO";
import DatabaseReactivation from "./DatabaseReactivation";

export default function DatabaseReactivationPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Bring Back Old Customers"
        description="Your old customer list is sitting on booked jobs. We text your past customers and dead leads, start real conversations, and book the ready ones straight onto your calendar. No ad spend."
        path="/database-reactivation"
      />
      <Navbar />
      <main className="pt-16 md:pt-[72px]">
        <DatabaseReactivation />
      </main>
      <Footer />
    </>
  );
}
